import { Component, Inject } from '@angular/core';
import { Navigation } from '../../entities';
import {
  DASHBOARD_ITEMS_CONFIGURATION_TOKEN,
  DashboardItemsConfigurationToken
} from '../../tokens';

@Component({
  selector: 'es-dashboard-core',
  templateUrl: './dashboard-core.component.html',
  styleUrls: ['./dashboard-core.component.scss']
})
export class DashboardCoreComponent {
  navigations: Navigation[];
  constructor(
    @Inject(DASHBOARD_ITEMS_CONFIGURATION_TOKEN)
    configuration: DashboardItemsConfigurationToken
  ) {
    this.navigations = configuration.navigations;
  }
}
